/**
 * @module CustomersMenu
 */

import Component from '../base/Component';
import CookieHelper from '../../scripts/backend/cookie_helper';
import './styles.css';

/**
 * Уведомление об использовании Cookie.
 */
export default class ContentRow extends Component {
    static className = 'cookie-panel';
}

$(document).ready(() => {
    if (document.cookie.match('accepted_privacy_policy') == null) {
        setTimeout(() => {
            $('.js-privacy-policy-cookie-block').fadeIn();
            console.log();
        }, 1000);
    }
});

/**
 * Принимаем пользовательское соглашение
 *
 */
const acceptPrivacyPolicy = function() {
    document.cookie = `accepted_privacy_policy=true; path=/; expires=${new CookieHelper().getMaxCookieDate()}`;
    $('.js-privacy-policy-cookie-block').slideUp('fast');
};

/**
 * Читаем пользовательское соглашение
 */
$(document).on('click', '.js-show-privacy-policy', function() {
    acceptPrivacyPolicy();
    window.location.href = $('.js-privacy-policy-cookie-block').attr('data-privacy-policy-href');
});

/**
 * Принимаем пользовательское соглашение моб
 */
$(document).on('click', '#cls', function() {
    acceptPrivacyPolicy();
});

/**
 * Принимаем пользовательское соглашение деск
 */
$(document).on('click', '.js-accept-privacy-policy', function() {
    acceptPrivacyPolicy();
});
